/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __assign, __rest } from "tslib";
import React from "react";
import { ICON_SIZE_STANDARD, ICON_SIZE_LARGE } from "../../constants";
import * as Classes from "../../classes";
export var SmallCross = function (_a) {
    var className = _a.className, color = _a.color, _b = _a.size, size = _b === void 0 ? ICON_SIZE_STANDARD : _b, _c = _a.title, title = _c === void 0 ? "small-cross" : _c, _d = _a.htmlTitle, htmlTitle = _d === void 0 ? title : _d, _e = _a.tagName, tagName = _e === void 0 ? "span" : _e, htmlProps = __rest(_a, ["className", "color", "size", "title", "htmlTitle", "tagName"]);
    var isLarge = size >= ICON_SIZE_LARGE;
    var pixelGridSize = isLarge ? ICON_SIZE_LARGE : ICON_SIZE_STANDARD;
    var viewBox = "0 0 " + pixelGridSize + " " + pixelGridSize;
    var path = (React.createElement("path", { d: isLarge
            ? "M11.41 10L14.7 13.29C14.89 13.47 15 13.72 15 14C15 14.55 14.55 15 14 15C13.72 15 13.47 14.89 13.29 14.71L10 11.41L6.71 14.71C6.53 14.89 6.28 15 6 15C5.45 15 5 14.55 5 14C5 13.72 5.11 13.47 5.29 13.29L8.59 10L5.3 6.71C5.11 6.53 5 6.28 5 6C5 5.45 5.45 5 6 5C6.28 5 6.53 5.11 6.71 5.29L10 8.59L13.29 5.3C13.47 5.11 13.72 5 14 5C14.55 5 15 5.45 15 6C15 6.28 14.89 6.53 14.71 6.71L11.41 10z"
            : "M9.41 8L11.7 10.29C11.89 10.47 12 10.72 12 11C12 11.55 11.55 12 11 12C10.72 12 10.47 11.89 10.29 11.71L8 9.41L5.71 11.71C5.53 11.89 5.28 12 5 12C4.45 12 4 11.55 4 11C4 10.72 4.11 10.47 4.29 10.29L6.59 8L4.3 5.71C4.11 5.53 4 5.28 4 5C4 4.45 4.45 4 5 4C5.28 4 5.53 4.11 5.71 4.29L8 6.59L10.29 4.3C10.47 4.11 10.72 4 11 4C11.55 4 12 4.45 12 5C12 5.28 11.89 5.53 11.71 5.71L9.41 8z", fillRule: "evenodd" }));
    if (tagName === null) {
        return (React.createElement("svg", __assign({ fill: color, "data-icon": "small-cross", width: size, height: size, viewBox: viewBox }, htmlProps),
            title && React.createElement("desc", null, title),
            path));
    }
    else {
        return React.createElement(tagName, __assign(__assign({}, htmlProps), { className: className + " " + Classes.ICON, title: htmlTitle }), React.createElement("svg", { fill: color, "data-icon": "small-cross", width: size, height: size, viewBox: viewBox },
            title && React.createElement("desc", null, title),
            path));
    }
};
export default SmallCross;
//# sourceMappingURL=small-cross.js.map